"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslatorTable = void 0;
const text_1 = require("../built-in/text");
const rule_1 = require("../rule/rule");
const or_1 = require("../built-in/or");
const list_1 = require("../built-in/list");
const repeat_1 = require("../built-in/repeat");
const opt_1 = require("../built-in/opt");
const assert_1 = require("../built-in/assert");
const set_1 = require("../built-in/set");
const pattern_1 = require("../built-in/pattern");
const any_1 = require("../built-in/any");
exports.TranslatorTable = {
    "rule": rule_1.RuleTranslator,
    "list": list_1.ListTranslator,
    "repeat": repeat_1.RepeatTranslator,
    "set": set_1.SetTranslator,
    "opt": opt_1.OptionalTranslator,
    "assert": assert_1.AssertTranslator,
    "text": text_1.TextTranslator,
    "or": or_1.OrTranslator,
    "pattern": pattern_1.PatternTranslator,
    "any": any_1.AnyCharacterTranslator
};
